<input
    #mPhotoInput
    (change)="mPhotoInputChanged($event)"
    accept="image/*"
    capture="environment"
    max="1"
    style="display: none"
    type="file"
/>
